import React from "react";
import styled from "styled-components";

const InputLabel = ({ style, children, isSmall }) => {
  return (
    <StyledInputLabel
      style={{
        ...style,
      }}
      $isSmall={isSmall}
    >
      {children}
    </StyledInputLabel>
  );
};

export default InputLabel;

const StyledInputLabel = styled.label.attrs((props) => {})`
  display: flex;
  flex-direction: column;
  height: fit-content;
  width: 100%;
  gap: 4px;
`;
